/**
 * Required checkout fields that can block a purchase. Kept as constants so that the flows,
 * the sections rendering the errors and the translation keys stay in sync.
 */
export const CHECKOUT_FIELD_PAYMENT_METHOD = 'paymentMethod'
export const CHECKOUT_FIELD_TERMS = 'terms'
export const CHECKOUT_FIELD_VEHICLES = 'vehicles'
export const CHECKOUT_FIELD_PERSONAL_DETAILS = 'personalDetails'
export const CHECKOUT_FIELD_FLIGHT_INFO = 'flightInfo'
export const CHECKOUT_FIELD_BILLING_ADDRESS = 'billingAddress'
